import { keepTrackApi } from '@app/keepTrackApi';
import { Line, LineColors } from './line';
export class SensorToMoonLine extends Line {
    sensor_;
    constructor(sensor) {
        super();
        this.sensor_ = sensor;
        this.color_ = LineColors.WHITE;
    }
    update() {
        const eci = this.sensor_.eci(keepTrackApi.getTimeManager().simulationTimeObj);
        const eciArr = [eci.x, eci.y, eci.z];
        this.updateVertBuf([eciArr, keepTrackApi.getScene().moons.Moon.position]);
    }
}
